import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "mw-live-player" }
const _hoisted_2 = { class: "ratio ratio-16x9 bg-dark rounded overflow-hidden position-relative" }
const _hoisted_3 = {
  ref: "videoEl",
  class: "w-100 h-100",
  style: {"object-fit":"contain","background":"#000"},
  muted: "",
  playsinline: "",
  controls: ""
}
const _hoisted_4 = {
  key: 0,
  class: "mw-loader",
  "aria-live": "polite"
}
const _hoisted_5 = ["aria-valuenow"]
const _hoisted_6 = {
  key: 1,
  class: "position-absolute top-50 start-50 translate-middle text-center px-5",
  style: {"pointer-events":"none"}
}
const _hoisted_7 = { class: "mb-2" }
const _hoisted_8 = { class: "text-gray-300 fs-7" }
const _hoisted_9 = {
  key: 2,
  class: "position-absolute rounded px-2 py-1",
  style: {"left":"8px","bottom":"8px","top":"auto","right":"auto","width":"auto","height":"auto","background":"rgba(0, 0, 0, 0.58)","max-width":"70%","pointer-events":"none","z-index":"5"}
}
const _hoisted_10 = {
  class: "d-flex align-items-center text-white fw-bold",
  style: {"font-size":"10.5px"}
}
const _hoisted_11 = {
  class: "text-white-50",
  style: {"font-size":"9.5px"}
}
const _hoisted_12 = {
  key: 0,
  class: "d-flex align-items-center justify-content-between mt-2"
}
const _hoisted_13 = {
  key: 0,
  class: "bullet bullet-dot bg-white me-2 mb-1"
}
const _hoisted_14 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("video", _hoisted_3, null, 512),
      (_ctx.state === 'loading')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"mw-loader__pulse\" aria-hidden=\"true\" data-v-cacf88ae><span class=\"mw-loader__ring\" data-v-cacf88ae></span><span class=\"mw-loader__ring\" data-v-cacf88ae></span><span class=\"mw-loader__ring\" data-v-cacf88ae></span><span class=\"mw-loader__core\" data-v-cacf88ae><i class=\"bi bi-camera-reels-fill\" data-v-cacf88ae></i></span></div>", 1)),
            (_openBlock(), _createElementBlock("div", {
              key: _ctx.loadStage,
              class: "mw-loader__label"
            }, _toDisplayString(_ctx.loadLabel), 1)),
            _createElementVNode("div", {
              class: "mw-loader__track",
              role: "progressbar",
              "aria-valuenow": Math.round(_ctx.loadProgress),
              "aria-valuemin": "0",
              "aria-valuemax": "100"
            }, [
              _createElementVNode("div", {
                class: "mw-loader__fill",
                style: _normalizeStyle({ width: _ctx.loadProgress + '%' })
              }, null, 4)
            ], 8, _hoisted_5),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "mw-loader__hint" }, [
              _createElementVNode("i", { class: "bi bi-lightning-charge-fill" }),
              _createTextVNode(" Mode hemat daya — video muncul dalam beberapa detik ")
            ], -1))
          ]))
        : (_ctx.overlayText)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("i", {
                  class: _normalizeClass(["bi text-gray-500", 
              _ctx.state === 'off'
                ? 'bi-power'
                : _ctx.state === 'offline'
                ? 'bi-camera-video-off'
                : 'bi-exclamation-triangle'
            ]),
                  style: {"font-size":"2rem"}
                }, null, 2)
              ]),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.overlayText), 1)
            ]))
          : _createCommentVNode("", true),
      (_ctx.scheduled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("i", {
                class: _normalizeClass(["bi me-1", 
              _ctx.scheduleActive
                ? 'bi-record-circle-fill text-success'
                : 'bi-pause-circle-fill text-warning'
            ])
              }, null, 2),
              _createTextVNode(" " + _toDisplayString(_ctx.scheduleActive ? "Streaming aktif" : "Jeda otomatis (hemat kuota)"), 1)
            ]),
            _createElementVNode("div", _hoisted_11, " Jadwal: " + _toDisplayString(_ctx.scheduleLabel) + " WIB ", 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showFooter)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("span", {
            class: _normalizeClass(["badge", _ctx.liveBadgeClass])
          }, [
            (_ctx.state === 'playing')
              ? (_openBlock(), _createElementBlock("span", _hoisted_13))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.liveBadgeText), 1)
          ], 2),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-sm btn-light-primary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.reload && _ctx.reload(...args))),
            disabled: _ctx.state === 'loading'
          }, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("i", { class: "bi bi-arrow-clockwise me-1" }, null, -1),
            _createTextVNode(" Muat Ulang ", -1)
          ]))], 8, _hoisted_14)
        ]))
      : _createCommentVNode("", true)
  ]))
}